var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 161,
    viewBox: "0 0 157 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M157 132.022C154.138 132.282 151.106 132.523 147.663 132.823V151.035H128.029C127.608 154.821 127.308 157.646 126.948 160.911L24 161.005L21 149H13L10 139.006H3L0 129.006L8 112.56V83.1012L17 82.0053L18 73.0053H96L98 63.0053L107 62.0053V53.0053H58L57 62.0263H3L0 49.0059L8 33.3389C10.662 32.818 13.8243 32.2371 17.487 31.5359V13.0053L114.669 13.4507L139 0.00585938L147 14.0059V20.0059H149L157 32.9983V132.022ZM57.9369 121.725H106.993V102.934H57.9369V121.725Z",
    fill: "#F86C14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M149 119.017C146.138 119.277 143.106 119.518 139.663 119.818V139.03H120.029L118.948 149H21L19 140L10 139L9 130L0 129.013V70.0959L9 69L10 60H88L90 50L99 49V40H50L49 49.021H0V20.3336C2.66197 19.8128 5.82429 19.2318 9.48699 18.5306V0.00585938L139.063 0V18.4104C142.485 18.9714 145.557 19.4321 149 19.9931V119.017ZM49.9369 108.72H98.9931V89.9286H49.9369V108.72Z",
    fill: "#FFC700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA);
export default __webpack_public_path__ + "static/media/A.bb9c3ea9facc900f93060164fb3cdc31.svg";
export { ForwardRef as ReactComponent };